import { render } from "./ShareFooter.vue?vue&type=template&id=57a6a08f&scoped=true"
import script from "./ShareFooter.vue?vue&type=script&lang=js"
export * from "./ShareFooter.vue?vue&type=script&lang=js"

import "./ShareFooter.vue?vue&type=style&index=0&id=57a6a08f&lang=less&scoped=true"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a6a08f"]])

export default __exports__